import axios from 'axios';

// Create axios instance
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle auth errors and global error handling
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle authentication errors
        if (error.response?.status === 401) {
            // Token expired or invalid
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
            return Promise.reject(error);
        }

        // Handle network errors
        if (!error.response) {
            error.code = 'NETWORK_ERROR';
            error.message = 'Network error. Please check your internet connection.';
        }

        // Handle server errors (5xx)
        if (error.response?.status >= 500) {
            error.message = 'Server error. Please try again later.';
        }

        // Handle too many requests (429)
        if (error.response?.status === 429) {
            error.message = 'Too many requests. Please wait a moment before trying again.';
        }

        return Promise.reject(error);
    }
);

export default apiClient; 